<script lang="ts">
	import { quadInOut } from 'svelte/easing';

	import CreateScWalletButton from './CreateSCWalletButton.svelte';
	import Wallet from '$lib/wallet/Wallet.svelte';
	import { fade } from 'svelte/transition';
	export let size: 'sm' | 'lg' = 'lg';
	export let source: string;
</script>

<div class="flex flex-col items-center">
	<img
		src="scwallet/wallet-icon.webp"
		alt="Create Wallet"
		class="{size == 'sm' ? 'h-20' : 'h-44'} animate-pulse m-10 sm:m-0"
		in:fade|global={{
			duration: 500,
			delay: 200,
			easing: quadInOut
		}}
	/>
	<div class="w-full sm:w-1/2">
		<CreateScWalletButton {source} />
	</div>
	<div class="text-fx-grey-400 text-xs sm:text-sm pt-3 text-center">
		Create Smart Contract Wallet to start trading
	</div>
	<div class="my-5 w-fit mx-auto block sm:hidden">
		<Wallet />
	</div>
</div>
